<style scoped lang="less">
.list-card {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;

}

.left-con, right-con {
  height: 100%;
}
</style>

<template>
  <div class="list-card">
    <div class="list-card-left" v-if="direction === 'left'">
      <slot name="left">
        左边内容
      </slot>
    </div>
    <div :class="{'list-card-center': true,[centerClass]: centerClass}">
      <slot name="center-top">
        中间上面内容
      </slot>
      <slot name="center-bottom">
        中间下面内容
      </slot>
    </div>
    <div class="list-card-right" v-if="direction === 'right'">
      <slot name="right">
        右边内容
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListCard', // 定义全局列表卡片布局组件
  props: {
    direction: { // 方向, 只能是 left right
      validator: value => ['right', 'left'].includes(value),
      default: 'right'
    },
    centerClass: { // 用于给中间的盒子设置类名
      type: String,
      default: ''
    }
  }
}
</script>
